import { apiClient } from 'pobble-components/dist/api'

const apiGetYearGroups = params => apiClient.get('/v3/year_groups', { params })

export { apiGetYearGroups }
